export default __webpack_public_path__ + "static/media/add_to_focus_area.1e439891.png";